import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Konami from 'react-konami';
import { map } from 'lodash';
import { Link } from 'react-router-dom';
import Fa from 'react-fontawesome';
import { Button } from 'react-bootstrap';
import UserTable from '../../../Setup/components/UserTable/UserTable';
// Import Actions
import { fetchOrganization } from '../../AdminActions';
import { fetchOrganizationUsers, requestInviteOrganizationUsers, updateOrganizationUser } from '../../../Setup/SetupActions';
import NumberDisplay from '../../../../components/number-display';
import Pusher from '../../../../components/pusher';
// Import Selectors
import { getViewOrganizationUsers, getViewOrganization } from '../../AdminReducer';

import { getUser } from '../../../Auth/AuthReducer';

class OrganizationDetailPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errors: null,
      hijack: false,
      selectedIds: [],
      invitings: false,
      currentWelcomeUser: null,
    };
    this.syncUsers = this.syncUsers.bind(this);
    this.toggleHijack = this.toggleHijack.bind(this);
    this.handleToggleSelect = this.handleToggleSelect.bind(this);
    this.checkboxSelection = this.checkboxSelection.bind(this);
    this.sendEmails = this.sendEmails.bind(this);
    this.handleOrganizationSendInvitationEmail = this.handleOrganizationSendInvitationEmail.bind(this);
    this.handleOrganizationSendInvitationEmailDone = this.handleOrganizationSendInvitationEmailDone.bind(this);
  }

  componentDidMount() {
    this.syncOrganization();
  }

  syncOrganization() {
    const { match: { params: { organizationID } } } = this.props;
    this.props.dispatch(fetchOrganization(organizationID));
  }

  syncUsers(params) {
    const { match: { params: { organizationID } } } = this.props;
    return this.props.dispatch(fetchOrganizationUsers(organizationID, params));
  }

  checkboxSelection({ data }) {
    return data && data.last_activity === null && data.logs === 0 && !data.pending_invite;
  }

  toggleHijack() {
    this.setState({ hijack: !this.state.hijack });
  }

  handleToggleSelect(users) {
    this.setState({ selectedIds: map(users, '_id') });
  }
  handleOrganizationSendInvitationEmail(user) {
    this.props.dispatch(updateOrganizationUser(user));
    this.setState({ currentWelcomeUser: user });
  }

  handleOrganizationSendInvitationEmailDone() {
    this.context.addNotification((
      <div>
        All welcome emails have been sent!
      </div>
    ));
    this.setState({ currentWelcomeUser: null });
  }


  sendEmails() {
    if (!this.state.invitings) {
      const { match: { params: { organizationID } } } = this.props;
      const { selectedIds } = this.state;
      this.setState({ invitings: true, selectedIds: [] }, () => {
        this.props.dispatch(requestInviteOrganizationUsers(organizationID, selectedIds))
          .then(
            () => {
              this.setState({ invitings: false });
            },
            () => {
              this.setState({ invitings: false });
            },
          );
      });
    }
  }

  renderMailLink() {
    const { selectedIds, invitings } = this.state;
    const hasSelected = selectedIds.length > 0;
    return (
      <span>
        {hasSelected &&
          <Button bsStyle="primary" disabled={invitings} onClick={this.sendEmails}>
            <Fa name="envelope" /> Send Welcome Emails (<NumberDisplay value={selectedIds.length} precision={0} />)
          </Button>
        }
        {!hasSelected &&
          <Button bsStyle="primary" disabled>
            <Fa name="envelope" /> Send Welcome Emails
          </Button>
        }
        &nbsp;&nbsp;&nbsp;
      </span>
    );
  }

  render() {
    const {
      loading, errors, hijack, selectedIds,
      currentWelcomeUser,
    } = this.state;
    const { organization, user } = this.props;
    return (
      <div className="container">
        {!loading && errors === null && organization && organization.display_name && <Helmet title={`${organization.display_name} | Organization Setup`} />}
        <div className="clearfix">
          <h2 className="page-sub-header">
            <Link to="/admin/organizations">All Organizations</Link>
            <span>&nbsp;<Fa name="angle-right" className="text-muted" />&nbsp;</span>
            <span>{organization.display_name}</span>
          </h2>
        </div>
        {!organization.is_demo && <Pusher key={`${organization._id}-organizationInvitationEmail`} event="organizationSendInvitationEmail" handler={this.handleOrganizationSendInvitationEmail} />}
        {!organization.is_demo && <Pusher key={`${organization._id}-organizationInvitationEmailDone`} event="organizationSendInvitationEmailDone" handler={this.handleOrganizationSendInvitationEmailDone} />}
        {user._id && user.role === 'superadmin' && <Konami easterEgg={this.toggleHijack} />}
        {!organization.is_demo &&
          <div>
            <UserTable
              key={organization._id}
              showOrganizationDetailColumn={false}
              selectable
              showEmailColumn={false}
              showHijack={hijack === true}
              organization={organization}
              toggleSelect={this.handleToggleSelect}
              selectedIds={selectedIds}
              topControl={this.renderMailLink()}
              checkboxSelection={this.checkboxSelection}
              fetchAction={this.syncUsers}
              flashRow={currentWelcomeUser}
            />
          </div>
        }
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
    users: getViewOrganizationUsers(state),
    organization: getViewOrganization(state),
  };
}

OrganizationDetailPage.propTypes = {
  user: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  organization: PropTypes.shape({}).isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  users: PropTypes.shape({}).isRequired,
};

OrganizationDetailPage.contextTypes = {
  router: PropTypes.object,
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(OrganizationDetailPage);
